import { createFileRoute } from "@tanstack/react-router";
import { RouteGuard } from "@/components/RouteGuard";
import { LanguageManagement } from "@/lib/lazyPages";

export const Route = createFileRoute("/admin/languages")({
  component: () => (
    <RouteGuard access={{ kind: "admin" }}>
      <LanguageManagement />
    </RouteGuard>
  ),
});
